import { Helmet } from 'react-helmet-async';
// remove unused lodash filter
import * as XLSX from 'xlsx';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  Container,
  Typography,
  TableContainer,
  Button,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogActions,
  TextField,
  TableHead,
  DialogContentText,
  DialogContent,
  Grid,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import { getToken } from '../utils/common';
import logger from '../utils/logger';

import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';

import { ReportListToolbar } from '../sections/@dashboard/user';

import USERLIST from '../_mock/rule';

// removed unused comparator helpers

// removed unused sorting utilities

export default function UserPage() {
  const [page, setPage] = useState(0);

  const [datenext, setdatenext] = useState(null);
  const [filterName, setFilterName] = useState('');
  const [data, setData] = useState([]);
  const [datestart, setdatestart] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [reportname, setreportname] = useState('');

  const handledatenext = (newValue) => {
    setdatenext(newValue);
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0); // Reset to first page when changing rows per page
    setRowsPerPage(Number.parseInt(event.target.value, 10));
  };
  const handledatestart = (newValue) => {
    setdatestart(newValue);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0); // Reset to first page when filtering
    fetchInfo(`${globalThis.REACT_APP_API_PURE}report/list?report_name=${event.target.value}`);
  };

  const fetchInfo = (url) =>
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((d) => setData(d))
      .catch((error) => {
        logger.apiError('fetchInfo', error, url);
        setData([]);
        // Show user-friendly error message
        if (error.message.includes('401')) {
          logger.warn('Authentication failed. Please login again.');
        } else if (error.message.includes('403')) {
          logger.warn('Access denied. Insufficient permissions.');
        } else if (error.message.includes('500')) {
          logger.error('Server error. Please try again later.', error);
        }
      });

  const fetchInfo2 = (url2) =>
    fetch(url2, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((d) => {})
      .catch((error) => {
        logger.apiError('fetchInfo2', error, url2);
        // Show user-friendly error message
        if (error.message.includes('401')) {
          logger.warn('Authentication failed. Please login again.');
        } else if (error.message.includes('403')) {
          logger.warn('Access denied. Insufficient permissions.');
        } else if (error.message.includes('500')) {
          logger.error('Server error. Please try again later.', error);
        }
      });

  const formatToGMT7 = (dateString) => {
    if (!dateString) return '';
    try {
      // Parse the date and convert to GMT+7
      const date = dayjs(dateString).utcOffset(7);
      // Format as DD-MM-YYYY HH.mm
      return date.format('DD-MM-YYYY HH.mm');
    } catch (error) {
      logger.error('Error formatting date:', error);
      return dateString; // Return original if parsing fails
    }
  };

  const fetchInfo3 = (url2, reportName = '') =>
    fetch(url2, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((d) => {
        if (d.data == null) {
          alert('Data Tidak Tersedia');
          return;
        }

        // Convert createdAt and updatedAt to GMT+7 format
        const processedData = d.data.map((item) => {
          const processedItem = { ...item };
          if (processedItem.createdAt) {
            processedItem.createdAt = formatToGMT7(processedItem.createdAt);
          }
          if (processedItem.updatedAt) {
            processedItem.updatedAt = formatToGMT7(processedItem.updatedAt);
          }
          return processedItem;
        });

        const worksheet = XLSX.utils.json_to_sheet(processedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        XLSX.writeFile(workbook, `result ${reportName}.xlsx`);
      })
      .catch((error) => {
        logger.apiError('fetchInfo3', error, url2);
        alert('Error generating report. Please try again.');
        // Show user-friendly error message
        if (error.message.includes('401')) {
          logger.warn('Authentication failed. Please login again.');
        } else if (error.message.includes('403')) {
          logger.warn('Access denied. Insufficient permissions.');
        } else if (error.message.includes('500')) {
          logger.error('Server error. Please try again later.', error);
        }
      });

  useEffect(() => {
    fetchInfo(`${globalThis.REACT_APP_API_PURE}report/list`);
    fetchInfo2(`${globalThis.REACT_APP_API_PURE}alert/list`);
  }, []);

  const [isDownloading, setIsDownloading] = useState(false);

  const downloadExcels = () => {
    if (isDownloading) return; // Prevent double-click
    setIsDownloading(true);
    const reportName = reportname;
    // Convert dayjs objects to ISO strings
    // DatePicker onChange returns dayjs objects, convert to ISO string
    // Set start date to beginning of day (00:00:00) and end date to end of day (23:59:59)
    const fromDate = datestart ? dayjs(datestart).startOf('day').toISOString() : '';
    const toDate = datenext ? dayjs(datenext).endOf('day').toISOString() : '';

    const handleXhrDownload = (url, reportName) => {
      return new Promise((resolve, reject) => {
        const link = document.createElement('a');
        link.href = url;
        link.download = reportName;
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.setRequestHeader('Authorization', `Bearer ${getToken()}`);
        xhr.responseType = 'blob';

        xhr.onload = () => {
          if (xhr.status === 200) {
            const blob = new Blob([xhr.response], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const blobUrl = URL.createObjectURL(blob);
            link.href = blobUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
            resolve();
          } else {
            reject(new Error(`HTTP error! status: ${xhr.status}`));
          }
        };
        xhr.onerror = () => reject(new Error('Network error'));
        xhr.send();
      });
    };

    let downloadPromise = null;
    if (reportName === 'Active Alerts - All') {
      downloadPromise = fetchInfo3(
        `${globalThis.REACT_APP_API_PURE}alert?status=open&status=inProgress&status=pendingApproval&status=pendingRollback&limit=10000&from=${fromDate}&to=${toDate}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName === 'Active Alerts - Open') {
      downloadPromise = fetchInfo3(
        `${globalThis.REACT_APP_API_PURE}alert?status=open&limit=10000&from=${fromDate}&to=${toDate}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName === 'Active Alerts - In Progress') {
      downloadPromise = fetchInfo3(
        `${globalThis.REACT_APP_API_PURE}alert?status=inProgress&limit=10000&from=${fromDate}&to=${toDate}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName === 'Active Alerts - Pending Approval') {
      downloadPromise = fetchInfo3(
        `${globalThis.REACT_APP_API_PURE}alert?status=pendingApproval&limit=10000&from=${fromDate}&to=${toDate}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName === 'Active Alerts - Pending Rollbacks') {
      downloadPromise = fetchInfo3(
        `${globalThis.REACT_APP_API_PURE}alert?status=pendingRollback&limit=10000&from=${fromDate}&to=${toDate}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName === 'Processed Alerts - All') {
      downloadPromise = fetchInfo3(
        `${globalThis.REACT_APP_API_PURE}alert?status=closed&limit=10000&from=${fromDate}&to=${toDate}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName === 'Processed Alerts - Rolled Back') {
      downloadPromise = fetchInfo3(
        `${globalThis.REACT_APP_API_PURE}alert?status=closed&closedStatus=rollback&limit=10000&from=${fromDate}&to=${toDate}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName === 'Processed Alerts - Kept') {
      downloadPromise = fetchInfo3(
        `${globalThis.REACT_APP_API_PURE}alert?status=closed&closedStatus=keep&limit=10000&from=${fromDate}&to=${toDate}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName === 'Web Verification') {
      downloadPromise = handleXhrDownload(
        `${globalThis.REACT_APP_API_PURE}report/interactive-verify?from=${fromDate}&to=${toDate}`,
        reportName
      );
    } else if (reportName === 'Unauthorized Updates') {
      downloadPromise = handleXhrDownload(
        `${globalThis.REACT_APP_API_PURE}report/unauthorized-update?from=${fromDate}&to=${toDate}`,
        reportName
      );
    } else if (reportName === 'Authorized Updates') {
      downloadPromise = handleXhrDownload(
        `${globalThis.REACT_APP_API_PURE}report/authorized-update?from=${fromDate}&to=${toDate}`,
        reportName
      );
    }

    if (downloadPromise) {
      downloadPromise
        .catch((error) => {
          logger.error('Error downloading report:', error);
        })
        .finally(() => {
          setIsDownloading(false);
        });
    } else {
      setIsDownloading(false);
    }
  };
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const { t } = useTranslation();

  // Filter out "Web Verification" from the data - moved here to ensure it's computed before render
  const filteredData = React.useMemo(() => {
    return (data?.data || []).filter((item) => item.report_name !== 'Web Verification');
  }, [data?.data]);

  // Calculate pagination based on filtered data
  const totalCount = filteredData.length;
  const maxPage = Math.max(0, Math.ceil(totalCount / rowsPerPage) - 1);
  const currentPage = Math.min(page, maxPage); // Ensure page doesn't exceed max

  const startIndex = currentPage * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedData = React.useMemo(() => {
    return filteredData.slice(startIndex, endIndex);
  }, [filteredData, startIndex, endIndex]);

  const emptyRows = Math.max(0, rowsPerPage - paginatedData.length);

  // Update page if it exceeds max page (e.g., after filtering)
  React.useEffect(() => {
    if (totalCount > 0 && page > maxPage) {
      setPage(maxPage);
    }
  }, [page, maxPage, totalCount]);

  return (
    <>
      <Helmet>
        <title> Report List | COVAS </title>
      </Helmet>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        maxWidth={'md'}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{t('GenerateReport.2')}</DialogTitle>
        <DialogContent>
          <Grid container direction={'row'} spacing={2}>
            <Grid item alignSelf={'center'}>
              <Typography>{t('GenerateReport.3')} : </Typography>
            </Grid>
            <Grid item>
              {' '}
              <div>
                {' '}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    onChange={handledatestart}
                    value={datestart ? dayjs(datestart) : null}
                    slotProps={{
                      textField: {
                        size: 'small',
                        fullWidth: true,
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </Grid>
            <Grid item alignSelf={'center'}>
              <Typography>{t('GenerateReport.4')} </Typography>
            </Grid>
            <Grid item>
              {' '}
              <div>
                {' '}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    onChange={handledatenext}
                    value={datenext ? dayjs(datenext) : null}
                    slotProps={{
                      textField: {
                        size: 'small',
                        fullWidth: true,
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('Close.1')}</Button>
          <Button onClick={downloadExcels} disabled={!datestart || !datenext || isDownloading}>
            {isDownloading ? 'Downloading...' : t('SubmitButton.1')}
          </Button>
        </DialogActions>
      </Dialog>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Report
          </Typography>
        </Stack>

        <Card>
          <ReportListToolbar numSelected={0} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <TableHead>
                  <TableRow className="custom-table-row">
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Nomor.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('ReportName.1')}
                    </StyledTableCell>

                    <StyledTableCell
                      align="right"
                      style={{ backgroundColor: '#E2F5FC', color: '#0E7496', paddingRight: '3vw' }}
                    >
                      {t('Actions.2')}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData.length > 0 ? (
                    paginatedData.map((item, rowIndex) => (
                      <TableRow hover key={item?.id ?? `report-${startIndex + rowIndex}`}>
                        <TableCell component="th" scope="row" alignItems="center">
                          {startIndex + rowIndex + 1}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {item.report_name}
                        </TableCell>

                        <TableCell align="right">
                          <Button
                            style={{ backgroundColor: 'rgb(79, 138, 226)' }}
                            size="small"
                            onClick={() => {
                              setreportname(item.report_name);
                              handleClickOpen();
                            }}
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                          >
                            {t('GenerateReport.1')}
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        {t('NoData.1') || 'No data available'}
                      </TableCell>
                    </TableRow>
                  )}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={3} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={currentPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={t('RowsPerPage.1')}
            labelDisplayedRows={({ from, to, count }) => {
              if (count === 0) {
                return `0-0 ${t('Of.1').toLowerCase()} 0`;
              }
              return `${from}-${to} ${t('Of.1').toLowerCase()} ${count !== -1 ? count : `more than ${to}`}`;
            }}
          />
        </Card>
      </Container>
    </>
  );
}
